module.exports = __webpack_public_path__ + "media/newstyle/images/icon-upload-fd14be402fccbdfa41d0810f2dfa2b13.svg";